import { Link } from 'react-router-dom';
import { DEFAULT_ROUTE } from '../utils/menuConfig.js';

export default function Forbidden() {
  return (
    <div className="container py-5 text-center" data-testid="forbidden-page">
      <i className="fa-solid fa-shield-halved fa-3x text-secondary mb-3" />
      <h1 className="display-5 font-weight-bold text-dark">403 — Forbidden</h1>
      <p className="text-muted mb-4">You don't have permission to access this page.</p>
      <Link to={DEFAULT_ROUTE} className="btn btn-primary">
        <i className="fa-solid fa-arrow-left mr-2" />Back to dashboard
      </Link>
    </div>
  );
}
